export default __webpack_public_path__ + "static/media/not-points.705a8eba.svg";